import * as React from 'react';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Title from './Title';
import StationsList from '../Data/sampleprojectdata.json';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
// Generate Order Data
function createData(id, name, Location, AssetId, category) {
  return { id, name, Location, AssetId, category };
}


function preventDefault(event) {
  event.preventDefault();
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};


export default function Stations() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [projectId, setProjectId] = React.useState(0);
  const [projectName, setProjectName] = React.useState('0');

  const getProject = (id, name) => {    
    setProjectId(id);
    localStorage.setItem('projectName', name);
    setProjectName(name);
    setOpen(true);
  };

  return ( 
    <React.Fragment>
      <Title>Stations</Title>
      <Table size="small">
        <TableHead>
          <TableRow>            
            <TableCell>Name</TableCell>
            <TableCell>Location</TableCell>
            <TableCell>AssetId</TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {StationsList.map((station, i) => (
            <TableRow key={i}>
              <TableCell>{station.name}</TableCell>
              <TableCell>{station.location}</TableCell>
              <TableCell>{station.assetId}</TableCell>
              <TableCell>
                <Button variant="contained" size="small" onClick={() => getProject(station.id, station.name)}>Load</Button>
              </TableCell>
              
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Link color="primary" href="#" onClick={preventDefault} sx={{ mt: 3 }}>
        See All Stations
      </Link>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h2" component="h2">
            {projectName}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Would you like to open this project?
          </Typography>
          <Button variant="contained" onClick={() =>  window.location.href = `/dashboard/operations`}>Load Project</Button>
        </Box>
      </Modal>

    </React.Fragment>
  );
}
